"use client";

import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
import styles from "./HotelGallerySwiper.module.css";

/**
 * @param {{ images: Array<{ id: string, src: string, alt: string }> }} props
 */
export default function HotelGallerySwiper({ images = [], maxSlides = 15 }) {
  return (
    <div className={styles.customPagination}>
      <Swiper
        modules={[Pagination]}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        }}
        // navigation
        spaceBetween={16}
        slidesPerView={1}
        loop={true}
      >
        {images.slice(0, maxSlides).map((image, index) => (
          <SwiperSlide key={`${image.id}-${index}`}>
            <div
              style={{
                position: "relative",
                aspectRatio: "215/144",
                width: "100%",
                overflow: "hidden",
                // borderRadius: 12,
              }}
            >
              <img
                src={image.src}
                alt={image.alt}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              {/* <span
                style={{
                  position: "absolute",
                  bottom: 8,
                  left: 12,
                  background: "rgba(0,0,0,0.45)",
                  color: "#fff",
                  fontSize: 12,
                  padding: "2px 8px",
                  borderRadius: 99,
                }}
              >
                {image.alt}
              </span> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
